import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import i18n from "../../i18n";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { I18nextProvider } from "react-i18next";

/* global document, Office, module, require */

const title = "Task Details Add-in";

const rootElement = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady(() => {
  root?.render(
    <FluentProvider theme={webLightTheme}>
      <I18nextProvider i18n={i18n}>
        <App title={title} />
      </I18nextProvider>
    </FluentProvider>
  );
});

if (module.hot) {
  module.hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
